// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1R4u2","content":"LayoutSettings_content__1vkVY"};